var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_heart_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3923 3.3917C11.528 3.31313 10.3351 4.41313 9.99943 4.78455C9.65657 4.42027 8.47086 3.31313 6.60657 3.3917C6.60657 3.3917 2.40657 3.3917 2.68514 7.95598C2.68514 7.95598 2.67086 11.956 9.89229 16.5488L9.99943 16.6131L10.1066 16.5488C17.328 11.956 17.3137 7.95598 17.3137 7.95598C17.5923 3.38455 13.3923 3.3917 13.3923 3.3917Z",
    fill: "#FF6B6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHeartIcon);
export default __webpack_public_path__ + "static/media/group_heart_icon.b1c683273b5bc42dface6e4b213f213b.svg";
export { ForwardRef as ReactComponent };